exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".email-container{margin-top:2rem;margin-bottom:1.5rem}.email-container p{margin-bottom:.755rem}.onboarding-consent-card{display:inline-flex;margin-bottom:.5rem;margin-right:.5rem;padding:1rem 1rem;max-height:5rem;align-items:center;justify-content:center;background-color:#fff;border:1px solid #c8c9c8;border-radius:5px}.onboarding-consent-card.active:hover{box-shadow:0 2px 12px;cursor:pointer;transition:box-shadow .24s cubic-bezier(0.215, 0.61, 0.355, 1)}", ""]);

// exports
